<template>
    <Card :size="CardSize.MEDIUM">
        <div class="routing-address-card">
            <div class="routing-address-card__header">
                <h3 class="routing-address-card__code typographies-paragraph-medium-semibold">
                    {{ address.code }}
                </h3>
                <CompassTag
                    :color="CompassEnums.TagColorType.GREEN"
                    :size="CompassEnums.TagSize.SMALL"
                >
                    {{ translations.activePill }}
                </CompassTag>
            </div>
            <CompassSwitch
                class="routing-address-card__switch"
                :modelValue="address.isDefault"
                :label="translations.defaultAddress"
                :size="CompassEnums.SwitchSize.MEDIUM"
                :orientation="CompassEnums.SwitchOrientation.LEFT"
                :disabled="address.isDefault"
                @change="onChange"
            />
        </div>
    </Card>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import Card from 'vcomponents/common/card/Card.vue';
import { CardSize } from 'types/components/common/Card.type';
import type { Translator } from 'js/shims-vue';
import type { RoutingAddress } from 'types/entities/einvoicing/routingAddress.type';

interface Props {
    address: RoutingAddress;
}

const props = defineProps<Props>();
const emit = defineEmits<{
    (event: 'setDefault', id: number): void;
}>();

const $t = inject('$t') as Translator;
const translations: Record<string, string> = {
    activePill: $t.__('overview.tabs.TabRoutingAddresses.card.active_pill'),
    defaultAddress: $t.__('overview.tabs.TabRoutingAddresses.card.default_address'),
};

const onChange = (value: boolean): void => {
    // The switch is disabled when the address is the current default, so this callback only
    // fires when the user activates a non-default address (value === true).
    if (value) {
        emit('setDefault', props.address.id);
    }
};
</script>

<style lang="scss" scoped>
.routing-address-card {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);

    &__header {
        align-items: center;
        display: flex;
        gap: var(--spacing-2);
    }

    &__code {
        margin: 0;
        word-break: break-all;
    }

    &__switch {
        width: fit-content;
    }
}
</style>
